import React from "react";

function PartenaireHomePage() {
  return <div>PartenaireHomePage</div>;
}

export default PartenaireHomePage;
